/**
 * Maps industry display names (from API) to translation keys.
 * Used for localizing industry options in browse filters.
 */
export const INDUSTRY_KEYS = {
  Digital: 'digital',
  Accounting: 'accounting',
  'Airlines/Aviation': 'airlinesAviation',
  'Alternative Dispute Resolution': 'alternativeDisputeResolution',
  'Alternative Medicine': 'alternativeMedicine',
  Animation: 'animation',
  'Apparel & Fashion': 'apparelFashion',
  'Architecture & Planning': 'architecturePlanning',
  'Arts and Crafts': 'artsAndCrafts',
  Automotive: 'automotive',
  'Aviation & Aerospace': 'aviationAerospace',
  Banking: 'banking',
  Biotechnology: 'biotechnology',
  'Broadcast Media': 'broadcastMedia',
  'Building Materials': 'buildingMaterials',
  'Business Supplies and Equipment': 'businessSuppliesAndEquipment',
  'Capital Markets': 'capitalMarkets',
  Chemicals: 'chemicals',
  'Civic & Social Organization': 'civicSocialOrganization',
  'Civil Engineering': 'civilEngineering',
  'Commercial Real Estate': 'commercialRealEstate',
  'Computer & Network Security': 'computerNetworkSecurity',
  'Computer Games': 'computerGames',
  'Computer Hardware': 'computerHardware',
  'Computer Networking': 'computerNetworking',
  'Computer Software': 'computerSoftware',
  Construction: 'construction',
  'Consumer Electronics': 'consumerElectronics',
  'Consumer Goods': 'consumerGoods',
  'Consumer Services': 'consumerServices',
  Cosmetics: 'cosmetics',
  Dairy: 'dairy',
  'Defense & Space': 'defenseSpace',
  Design: 'design',
  'Education Management': 'educationManagement',
  'E-learning': 'eLearning',
  'Electrical/Electronic Manufacturing': 'electricalElectronicManufacturing',
  Entertainment: 'entertainment',
  'Environmental Services': 'environmentalServices',
  'Events Services': 'eventsServices',
  'Executive Office': 'executiveOffice',
  'Facilities Services': 'facilitiesServices',
  Farming: 'farming',
  'Financial Services': 'financialServices',
  'Fine Art': 'fineArt',
  Fishery: 'fishery',
  'Food & Beverages': 'foodBeverages',
  'Food Production': 'foodProduction',
  'Fund-Raising': 'fundRaising',
  Furniture: 'furniture',
  'Gambling & Casinos': 'gamblingCasinos',
  'Glass, Ceramics & Concrete': 'glassCeramicsConcrete',
  'Government Administration': 'governmentAdministration',
  'Government Relations': 'governmentRelations',
  'Graphic Design': 'graphicDesign',
  'Health, Wellness and Fitness': 'healthWellnessAndFitness',
  'Higher Education': 'higherEducation',
  'Hospital & Health Care': 'hospitalHealthCare',
  Hospitality: 'hospitality',
  'Human Resources': 'humanResources',
  'Import and Export': 'importAndExport',
  'Individual & Family Services': 'individualFamilyServices',
  'E-commerce': 'eCommerce',
  'Industrial Automation': 'industrialAutomation',
  'Information Services': 'informationServices',
  'Information Technology and Services': 'informationTechnologyAndServices',
  Insurance: 'insurance',
  'International Affairs': 'internationalAffairs',
  'International Trade and Development': 'internationalTradeAndDevelopment',
  Internet: 'internet',
  'Investment Banking': 'investmentBanking',
  'Investment Management': 'investmentManagement',
  'Investment Management ': 'investmentManagement',
  Judiciary: 'judiciary',
  'Law Enforcement': 'lawEnforcement',
  'Law Practice': 'lawPractice',
  'Legal Services': 'legalServices',
  'Legislative Office': 'legislativeOffice',
  'Leisure, Travel & Tourism': 'leisureTravelTourism',
  Libraries: 'libraries',
  'Logistics and Supply Chain': 'logisticsAndSupplyChain',
  'Luxury Goods & Jewelry': 'luxuryGoodsJewelry',
  Machinery: 'machinery',
  'Management Consulting': 'managementConsulting',
  Maritime: 'maritime',
  'Marketing and Advertising': 'marketingAndAdvertising',
  'Market Research': 'marketResearch',
  'Mechanical or Industrial Engineering': 'mechanicalOrIndustrialEngineering',
  'Media Production': 'mediaProduction',
  'Medical Devices': 'medicalDevices',
  'Medical Practice': 'medicalPractice',
  'Mental Health Care': 'mentalHealthCare',
  Military: 'military',
  'Mining & Metals': 'miningMetals',
  'Motion Picture and Film': 'motionPictureAndFilm',
  'Museums and Institutions': 'museumsAndInstitutions',
  Music: 'music',
  Nanotechnology: 'nanotechnology',
  Newspapers: 'newspapers',
  'Nonprofit Organization Management': 'nonprofitOrganizationManagement',
  'Oil & Energy': 'oilEnergy',
  'Online Media': 'onlineMedia',
  'Outsourcing/ Offshoring': 'outsourcingOffshoring',
  'Performing Arts': 'performingArts',
  Photography: 'photography',
  Plastics: 'plastics',
  'Professional Training & Coaching': 'professionalTrainingCoaching',
  'Package/ Freight Delivery': 'packageFreightDelivery',
  'Political Organization': 'politicalOrganization',
  'Program Development': 'programDevelopment',
  'Packaging and Containers': 'packagingAndContainers',
  Pharmaceuticals: 'pharmaceuticals',
  'Primary/ Secondary Education': 'primarySecondaryEducation',
  'Paper & Forest Products': 'paperForestProducts',
  Philanthropy: 'philanthropy',
  Printing: 'printing',
  'Public Policy': 'publicPolicy',
  'Public Relations and Communications': 'publicRelationsAndCommunications',
  'Public Safety': 'publicSafety',
  Publishing: 'publishing',
  'Railroad Manufacture': 'railroadManufacture',
  Ranching: 'ranching',
  'Real Estate': 'realEstate',
  'Recreational Facilities and Services': 'recreationalFacilitiesAndServices',
  'Religious Institutions': 'religiousInstitutions',
  'Renewables & Environment': 'renewablesEnvironment',
  Research: 'research',
  Restaurants: 'restaurants',
  Retail: 'retail',
  'Security and Investigations': 'securityAndInvestigations',
  Semiconductors: 'semiconductors',
  Shipbuilding: 'shipbuilding',
  'Sporting Goods': 'sportingGoods',
  Sports: 'sports',
  'Staffing and Recruiting': 'staffingAndRecruiting',
  Supermakets: 'supermakets',
  Telecommunications: 'telecommunications',
  Textiles: 'textiles',
  'Think Tanks': 'thinkTanks',
  Tobacco: 'tobacco',
  'Translation and Localization': 'translationAndLocalization',
  'Transportation/ Trucking/ Railroad': 'transportationTruckingRailroad',
  Utilities: 'utilities',
  'Venture Capital & Private Equity': 'ventureCapitalPrivateEquity',
  Veterinary: 'veterinary',
  Warehousing: 'warehousing',
  Wholesale: 'wholesale',
  'Wine and Spirits': 'wineAndSpirits',
  Wireless: 'wireless',
  'Writing and Editing': 'writingAndEditing',
  Procurement: 'procurement',
  'Software Development': 'softwareDevelopment',
  'Retail Sales': 'retailSales',
  'Sales and Related': 'salesAndRelated',
  'Open Submission': 'openSubmission',
  'Business Development': 'businessDevelopment',
  'Accounting and Finance': 'accountingAndFinance',
  'Clerical and Administrative': 'clericalAndAdministrative',
  'IT Services and IT Consulting': 'itServicesAndItConsulting',
  'Education Administration Programs': 'educationAdministrationPrograms',
  'Outsourcing and Offshoring Consulting': 'outsourcingAndOffshoringConsulting',
  'Motor Vehicle Manufacturing': 'motorVehicleManufacturing',
  'Non-profit Organizations': 'nonProfitOrganizations',
  'Hospitals and Health Care': 'hospitalsAndHealthCare',
  'Food and Beverage Services': 'foodAndBeverageServices',
  'Pharmaceutical Manufacturing': 'pharmaceuticalManufacturing',
  'Truck Transportation': 'truckTransportation',
  'Industrial Machinery Manufacturing': 'industrialMachineryManufacturing',
};
